import React__default from 'react';
import { IconNavigationArrowLeftCircle, IconNavigationArrowRightCircle } from 'nicollet-icons-react';
import { FilmstripNavButtonElement } from './styles.js';

var DIRECTION_TO_ARIA_LABEL = {
  back: 'previous page',
  forward: 'next page'
}; // eslint-disable-next-line react/display-name

var FilmstripNavButton = React__default.memo(function (_ref) {
  var ariaLabel = _ref.ariaLabel,
      direction = _ref.direction,
      _ref$hiddenInitially = _ref.hiddenInitially,
      hiddenInitially = _ref$hiddenInitially === void 0 ? false : _ref$hiddenInitially;
  var Icon = direction === 'back' ? IconNavigationArrowLeftCircle : IconNavigationArrowRightCircle;
  return React__default.createElement(FilmstripNavButtonElement, {
    "aria-hidden": hiddenInitially,
    "aria-label": ariaLabel ? ariaLabel : DIRECTION_TO_ARIA_LABEL[direction],
    "data-direction": direction,
    tabIndex: hiddenInitially ? -1 : undefined
  }, React__default.createElement(Icon, {
    width: "100%"
  }));
});
FilmstripNavButton.displayName = 'FilmstripNavButton';

export { FilmstripNavButton };
